import { PayloadAction, createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import { Page, Pageable, defaultPageContent } from "../admin/AdminSlice"
import { RootState } from "../../app/store"
import axios from "axios"
import { API_BASE } from "../../app/const"
import { fireauth } from "../auth/AuthSlice"

export interface SlugState {
  slugs: Page<Slug>
  loading: boolean
  error?: string
}
export interface Slug {
  id: string
  slug: string
  userEmail: string
  address: string
  createdBy: string
  createdTime: string
}
const initialState: SlugState = {
  slugs: defaultPageContent,
  loading: false
}
export const getSlugsAsync = createAsyncThunk(
  'slug/getSlugsAsync', async ({ page, mode, arg }: { page: Pageable, mode: 'all' | 'my' | 'myDomain' | 'byEmail' | 'byEmailDomain', arg: string }, { getState }) => {
    const state = getState() as RootState
    if (state) {
      const response = await axios.get(`${API_BASE}apps/slugs/${mode}` + (arg.length ? ('/' + arg) : ''), {
        params: page,
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
          "Authorization": `Bearer ${await fireauth.currentUser?.getIdToken()}`
        }
      })
      return response.data
    }
  }
)

const slugSlice = createSlice({
  name: 'slug',
  initialState,
  reducers: {
    slugStateChange: (state, action: PayloadAction<{ slug: Page<Slug> }>) => {
      state.slugs = action.payload.slug
    }
  }, extraReducers: (builder) => {
    builder
      .addCase(getSlugsAsync.pending, (state) => {
        state.loading = true
      })
      .addCase(getSlugsAsync.fulfilled, (state, action) => {
        state.loading = false
        if (action.payload) {
          state.slugs = action.payload
        }
      })
      .addCase(getSlugsAsync.rejected, (state, action) => {
        state.loading = false
        state.error = action.error.message
      })
  }
})

export const { slugStateChange } = slugSlice.actions
export const selectSlugs = (state: RootState) => state.slugs.slugs
export const selectSlugLoading = (state: RootState) => state.slugs.loading
export const selectSlugError = (state: RootState) => state.slugs.error

export default slugSlice.reducer
